import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import { Button } from '../../../../../components/ui/button'
import CurrencyTab from './currency-tab'
import { Tablist, TablistItem } from '../../../../../components/ui/tablist'
import KassaTab from './kassa-tab'

const HomePage = () => {
  const { t } = useTranslation()
  const [selected_tab, setselected_tab] = useState(window.sessionStorage.getItem('vreemde-valuta-tab') || 'foreign-currency');

  return (
    <div className="w-full p-4 overflow-auto max-h-[100dvh] md:p-8">
        <div className='flex items-center justify-between'>
            <h1 className='text-2xl font-semibold'>{t("settings.fc.title")}</h1>
            {selected_tab === 'foreign-currency' && <Link to="add"><Button>{t("settings.fc.new")}</Button></Link>}
            {/* {selected_tab === 'kassa' && <Link to="add-kassa"><Button>Nieuwe kassa</Button></Link>} */}
        </div>

        <div className='mt-4'>
          <Tablist value={selected_tab} onValueChange={(v)=>{window.sessionStorage.setItem('vreemde-valuta-tab', v); setselected_tab(v)}}>
            <TablistItem value='foreign-currency'>{t("settings.fc.title")}</TablistItem>
            <TablistItem value='kassa'>{t("settings.fc.kassas")}</TablistItem>
          </Tablist>
        </div>

        {selected_tab === 'foreign-currency' && <CurrencyTab />}
        {selected_tab === 'kassa' && <KassaTab />}
    </div>
  )
}

export default HomePage
